import { createContext } from 'react';

export interface EditorNavbarContextProps {
  disabledUndoRedo: boolean;
  setDisabledUndoRedo: (disabled: boolean) => void;
}

export const EditorNavbarContext = createContext<EditorNavbarContextProps>({
  disabledUndoRedo: false,
  setDisabledUndoRedo: () => void 0,
});
